/* eslint-disable no-restricted-globals */
import React from 'react';
import Router from 'routes';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@material-ui/core/styles';

import MainTheme from 'assets/styles/themes';

import { AuthProvider } from 'providers/AuthProvider';

import { containerStyles } from 'components/SnackMessage/styles';

const App = () => {
  const classes = containerStyles();

  return (
    <AuthProvider>
      <ThemeProvider theme={MainTheme}>
        <SnackbarProvider classes={{ containerRoot: classes.containerRoot }} maxSnack={3}>
          <Router />
        </SnackbarProvider>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
